import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    Renderer2,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {clone} from "../../extensions";

@Component({
    selector: 'ig-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccordionComponent {
    @Input() public id: string;
    @Input() public icon: string;
    @Input() public icon2: string;
    @Input() public title: string;
    @Input() public iconTooltip: string;
    @Input() public expanded = false;
    @Input() public disabled: boolean;
    @Input() public maxHeight = 0;
    public display = 'none';
    public isFiltering = false;
    @ViewChild('header') public header: ElementRef;
    @ViewChild('main') public main: ElementRef;
    @Output() onIconClick: EventEmitter<any> = new EventEmitter();
    @Output() onIcon2Click: EventEmitter<any> = new EventEmitter();
    @Output() onExpand: EventEmitter<any> = new EventEmitter();
    @Output() onFold: EventEmitter<any> = new EventEmitter();
    @Output() onClearFilter: EventEmitter<any> = new EventEmitter();

    public initialTitle = '';

    constructor() {
    }

    public ngAfterContentInit() {
        this.initialTitle = clone(this.title);
        this.header.nativeElement.onkeypress = ($event) => {
            if ($event && $event.key === 'Enter') {
                this.toggle($event);
            }
        };
    }

    public onClose() {
        this.expanded = false;
    }

    public close() {
        this.expanded = false;
        this.display = 'none';
        this.onFold.emit();
    }

    public open() {
        this.expanded = true;
        this.display = 'block';
        this.onExpand.emit();
    }

    public iconClick($event: Event) {
        $event.stopPropagation();
        this.onIconClick.emit();
    }
    public icon2Click($event: Event) {
        $event.stopPropagation();
        this.onIcon2Click.emit();
    }

    public toggle($event?) {
        if ($event) {
            $event.stopPropagation();
        }
        if (this.disabled) {
            return;
        }

        this.expanded = !this.expanded;

        if (this.expanded) {
            this.display = 'block';
            // this.header && this.header.nativeElement.setAttribute('aria-expanded', 'true');
            this.onExpand.emit();
        } else {
            this.display = 'none';
            this.onFold.emit();
            // this.header && this.header.nativeElement.setAttribute('aria-expanded', 'false');
        }
    }

    public setFilter(title: string, isFiltering = true) {
        this.title = title;
        this.isFiltering = isFiltering;
    }

    public clearFilter($event?: Event, emitEvent = true) {
        $event && $event.stopPropagation();
        this.setFilter(this.initialTitle, false);
        emitEvent && this.onClearFilter.emit();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/accordion/accordion.component.ts